import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ToolbarOuterContainer = styled.div`
  display: flex;
  flex: 0;
  min-width: 3rem;
`;
const ToolbarContainer = styled.div`
  direction: rtl;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  background: #262626;
  width: 100%;
  max-width: 3rem;
  text-align: right;
  transition: max-width 0.3s ease;
  right: 0;
  top: ${props => props.top || 0};
  bottom: ${props => props.bottom || 0};
  position: fixed;
  z-index: 99;

  &:hover {
    max-width: ${props => props.maxWidth || "10rem"};
  }

  &::-webkit-scrollbar {
    width: 7px;
    background-color: #262626;
  }

  &::-webkit-scrollbar-track {
    background: rgba(237, 237, 237, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(237, 237, 237, 0.2);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(237, 237, 237, 0.4);
  }
`;

const ToolbarList = styled.ul`
  margin: 0;
  padding: 0;
`;

class Toolbar extends PureComponent {
  render() {
    return (
      <ToolbarOuterContainer>
        <ToolbarContainer
          maxWidth={this.props.maxWidth}
          bottom={this.props.bottom}
          top={this.props.top}
        >
          <ToolbarList>{this.props.children}</ToolbarList>
        </ToolbarContainer>
      </ToolbarOuterContainer>
    );
  }
}

Toolbar.defaultProps = {
  children: [],
  bottom: "10rem",
  top: "0",
  maxWidth: "10rem"
};

Toolbar.propTypes = {
  children: PropTypes.node,
  bottom: PropTypes.string,
  top: PropTypes.string,
  maxWidth: PropTypes.string
};

export default Toolbar;



// WEBPACK FOOTER //
// ./app/components/Toolbar/Toolbar.js